import { Link } from 'react-router'

export default function NotFound() {
  return (
    <section className="p-6">
      <h2 className="font-sans text-[13px] font-bold tracking-[0.18em] uppercase">Page not found</h2>
      <p className="mt-2 font-mono text-[11px] tracking-[0.1em] text-paper-50 uppercase">
        <Link to="/strategies" className="underline">
          Back to strategies
        </Link>
      </p>
    </section>
  )
}
